import { jsx as _jsx } from "react/jsx-runtime";
import { HeaderWrapper } from './Header.style';
const Header = ({ children }) => (_jsx(HeaderWrapper, { children: children }));
export default Header;
